module.exports = __webpack_public_path__ + "static/img/banner-2020-08-18.eb5614f.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/imgs/banner-2020-08-18.png
// module id = g0mo
// module chunks = 1